// Accurate as of Sept 28, 2022
export var USER_RESOURCE;
(function (USER_RESOURCE) {
    USER_RESOURCE["INTERNAL"] = "internal";
})(USER_RESOURCE || (USER_RESOURCE = {}));
// Accurate as of Sept 28, 2022
export var USER_RESOURCE_MODE;
(function (USER_RESOURCE_MODE) {
    USER_RESOURCE_MODE["NONE"] = "none";
    USER_RESOURCE_MODE["RW"] = "rw";
})(USER_RESOURCE_MODE || (USER_RESOURCE_MODE = {}));
//# sourceMappingURL=User.js.map